/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.isVisible = false;
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick);
      
      // 创建哨兵元素用于 Intersection Observer
      this.createSentinel();
    }

    createSentinel() {
      const sentinel = document.createElement('div');
      sentinel.style.height = '1px';
      sentinel.style.visibility = 'hidden';
      
      // 在页面顶部插入哨兵元素
      document.body.insertBefore(sentinel, document.body.firstChild);
      
      // 使用 Intersection Observer 监听哨兵元素
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 当哨兵元素不可见时，说明已滚动过一屏
            this.updateVisibility(!entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      
      observer.observe(sentinel);
    }

    updateVisibility(shouldShow) {
      if (shouldShow && !this.isVisible) {
        this.classList.add('back-to-top--active');
        this.isVisible = true;
      } else if (!shouldShow && this.isVisible) {
        this.classList.remove('back-to-top--active');
        this.isVisible = false;
      }
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}